import { FC } from 'react'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface PhotoGridAddSlotProps {
  disabled?: boolean
  inputId: string
}

export const PhotoGridAddSlot: FC<PhotoGridAddSlotProps> = ({
  disabled,
  inputId,
}) => {
  const isDisabled = Boolean(disabled)

  return (
    <label
      className={s.slot}
      htmlFor={isDisabled ? undefined : inputId}
      aria-label="Добавить фото"
      aria-disabled={isDisabled}
    >
      <span className={s.plus}>
        <AppIcon
          id={AllIcons.CIRCLE_PLUS}
          width={24}
          height={24}
        />
      </span>
    </label>
  )
}
